export default "__VITE_ASSET__56dc23ad__"